import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      months: [
        { number: '01', title: 'Jan' },
        { number: '02', title: 'Feb' },
        { number: '03', title: 'Mar' },
        { number: '04', title: 'Apr' },
        { number: '05', title: 'May' },
        { number: '06', title: 'Jun' },
        { number: '07', title: 'Jul' },
        { number: '08', title: 'Aug' },
        { number: '09', title: 'Sep' },
        { number: '10', title: 'Oct' },
        { number: '11', title: 'Nov' },
        { number: '12', title: 'Dec' },
      ],
    }
  },
  mounted() {},
  computed: {
    years: () => {
      const year = new Date().getFullYear()
      return Array.from({ length: 10 }, (value, index) => {
        let y = year + index
        return {
          number: y.toString().substr(-2),
          title: y,
        }
      })
    },
    ...mapGetters(['processInProgress', '_T']),
  },
  methods: {},
}
